<template>
  <Container>
    <h1>Score du match</h1>

    <div class="card">
        <div class="matchTitle">
          <div class="center-align">
                <p
                  v-for="player in match.leftPlayers"
                  v-bind:key="player.id"
                >{{player.firstname}} {{player.name}}</p>
              </div>
              <div class="center-align">
                <p>vs</p>
              </div>
              <div class="center-align">
                <p
                  v-for="player in match.rightPlayers"
                  v-bind:key="player.id"
                >{{player.firstname}} {{player.name}}</p>
              </div>          
        </div>

        <div class="setContainer">
          <div class="center-align">
              <p><input v-model="set1.leftResult" type="number" /></p>
            </div>
            <div class="center-align">
              <p>Set 1</p>
            </div>
            <div class="center-align">
              <p><input v-model="set1.rightResult" type="number"/></p>
            </div>
        </div>

        <div class="setContainer">
          <div class="center-align">
              <p><input v-model="set2.leftResult" type="number" /></p>
            </div>
            <div class="center-align">
              <p>Set 2</p>
            </div>
            <div class="center-align">
              <p><input v-model="set2.rightResult" type="number"/></p>
            </div>
        </div>
    </div>

    <div class="buttonBar">
      <a class="button" v-on:click="updateScore()">
        <i class="material-icons right">save</i>Enregistrer
      </a>
    </div>
  </Container>  
</template>

<script>
// @ is an alias to /src
import Container from "@/components/Container.vue";
import scoreService from '@/services/ScoreService';
import axios from "axios";

export default {
  name: "score",
  data: function() {
    return {
      set1: {},
      set2: {},
      match: {}
    };
  },
  components: {
    Container
  },
  watch: {
    '$route.params.id': function(newId, oldId){
      this.initViewModel(newId);
    }
  },
  mounted() {
    this.initViewModel(this.$route.params.id);
  },
  methods: {
    updateScore(){
      var score = scoreService.calculateScoreFromSets(this.set1, this.set2);
      axios.post("/matches/" + this.match.id, score).then(response => {
        this.$snack.success('Score enregistré')
      });
    },
    initViewModel(matchId){
      this.match = this.$store.state.matches.filter(match => match.id === Number(matchId))[0];
      var score = this.match.score;
      if (score && score.sets && score.sets.length == 2){
        this.set1 = score.sets[0];
        this.set2 = score.sets[1];
      } else{
          this.set1 = {
            leftResult: "",
            rightResult: ""
          };
          this.set2 = {
            leftResult: "",
            rightResult: ""
          };
        }
    }
  }
};
</script>

<style scoped>
.card{
  box-shadow: 0.1em 0.2em 0.4em #ddd;
}
.matchTitle{
  display: grid;
  grid-template-columns: 4fr 1fr 4fr;
  background-color: #f1f1f1;
  font-weight: bold;
}
.center-align{
  text-align: center;
}
.setContainer{
  display: grid;
  grid-template-columns: 4fr 1fr 4fr;
  padding-top: 30px;
  padding-bottom: 30px;
}
input{
  width: 80px;
  padding: 6px 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 3px #ddd;
  font-size: 1.5em;
}
</style>